import { render, staticRenderFns } from "./Unsubscibe.vue?vue&type=template&id=61e6e15c&scoped=true&"
import script from "./Unsubscibe.vue?vue&type=script&lang=ts&"
export * from "./Unsubscibe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e6e15c",
  null
  
)

export default component.exports